module.exports = __webpack_public_path__ + "img/img2_3.aac9114f.jpeg";